export enum LoginType {
    ms365 = 'ms365',
    nonSso = 'nonSSo',
    adminJump = 'adminJump',
    sso = 'sso',
}
